export default "__VITE_ASSET__CEgQ7qko__"